import React from "react";
import { Card } from "../../../../shared/components/ui/Card";
import { InfoField } from "../../../../shared/components/ui/InfoField";
import type { MaintenanceType } from "../../../../api/client/types/catalog.types";

interface MaintenanceNewDetailFieldsProps {
  maintenanceType: MaintenanceType;
}

/**
 * MaintenanceNewDetailFields
 * Renders only the maintenance-specific detail fields in read-only format.
 * Designed to be used within a parent detail component that handles common fields.
 */
export const MaintenanceNewDetailFields: React.FC<
  MaintenanceNewDetailFieldsProps
> = ({ maintenanceType }) => {
  return (
    <Card variant="formSection">
      <h2 className="text-lg font-medium text-gray-800 mb-4">
        Información de Mantenimiento
      </h2>
      <InfoField label="Tipo de Novedad" value={maintenanceType.name} />
    </Card>
  );
};

